export default __webpack_public_path__ + "static/media/ico-aws-red-shift-score-elevated.6a69fc62.svg";